<template>
  <div class="verifyCode" v-show="showImage">
    <el-form :model="form" :rules="rules" ref="ruleForm" @submit.native.prevent>
      <el-form-item class="itemClass" label="" label-width="0" prop="verifyCode">
        <img
          class="imgClass"
          draggable="false"
          :src="imgSrc"
          alt=""
          @click="getVerifyCode"
        />
        <el-input v-model="form.verifyCode" style="width: 130px;" placeholder="请输入验证码"></el-input>
          <!-- style="
            width: 40%;
            height: 45px;
            background: #eee;
            padding: 2px 0 2px 20px;
            cursor: pointer;
            position: absolute;
            top: 210px;
            left: 60%;
          " -->
          <div class="genIcon"></div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import requestActiveLicense from "~/request/requestActiveLicense";
export default {
  data(){
    return{
      // 是否校验过
      ifVerification: false,
      checkStatus: false,
      showImage: false,
      imgSrc: '',
      verifyKey: '',
      form:{
        verifyCode: ''
      },
      rules:{
        verifyCode:[
          // { required: true, message: '请输入验证码', trigger: ['change'] },
          { validator: this.verifyCodeValidate, trigger: ['change'] }
        ],
      },
    }
  },
  created(){
    this.getVerifyCode();
  },
  methods:{
    verifyCodeValidate(rule, value, callback){
      if((!this.ifVerification) && value === ''){
        return callback('请输入验证码');
      }
      if(this.ifVerification && value.length < 4){
        return callback('验证码错误或已过期')
      }
      if (value.length < 4) {
        return callback();
      }
      let params = {
        "verifyKey": this.verifyKey,
        "verifyCode": value,
      };
      requestActiveLicense.verification(params).then((res) => {
        this.checkStatus = res.res;
        this.ifVerification = true;
        if (!res.res) {
          this.form.verifyCode = '';
          this.getVerifyCode();
          callback('验证码错误或已过期');
          return;
        }
        callback();
      }).catch((error) => {
        // console.error(error);
      })
      
    },
    //请求验证码
    getVerifyCode() {
      requestActiveLicense.captcha().then(res => {
        this.showImage = res.res.verifyCode ? true : false;
        this.imgSrc = res.res.verifyCode;
        this.verifyKey = res.res.verifyKey;
      });
    },
    getVail(){
      return new Promise((resolve, reject)=> {
        if(this.checkStatus){
          resolve();
        }else{
          this.$refs.ruleForm.validate((valid) => {
            if(valid){
              resolve();
            }else{
              reject();
            }
          })
        }
      })
    },
    getData(){
      return {
        verifyKey,
        'verifyCode': this.form.verifyCode
      };
    }
  }
}
</script>
<style lang="less" scoped>
.verifyCode{
  display: inline-block;
  .el-form-item{
    margin-bottom: 0;
    /deep/ .el-form-item__error{
      margin-left: 146px;
    }
  }
  .itemClass{
    .imgClass{
      height: 30px;
      width: 130px;
      vertical-align: bottom;
      cursor: pointer;
      margin-right: 12px;
    }
    .genIcon{
      margin: 0 12px;
      width: 1px;
      height: 21px;
      border-left: 1px solid #C0C4CC;
      display: inline-block;
      vertical-align: middle;
    }
  }
}
</style>